import {Page} from '../../common/services';

export class IPageNode {
  item: any;
  name: string;
  id?: number;
  level?: number;
  is_default?: boolean;
  children?: IPageNode[];
  data?: Page;
  expandable?: boolean;
}

/** Flat node with expandable and level information */
export class IPageFlatNode {
  item: any;
  expandable: boolean;
  name: string;
  level: number;
  id: number;
}
